export default "/survey_assets/images/abramsonLogo.496142f8126c5c5eea5295d689f4d9c9.png";